export default "__VITE_ASSET__DuB$UtAS__"